import { OktaAuthGuard } from '@okta/okta-angular';
import { Observable } from 'rxjs';

import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AUTH_PROVIDER_TOKEN, AuthProvider } from '../tokens/auth-provider.token';
import { AuthGuardService } from './auth-guard.service';
import { MsalGuard } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class DynamicAuthGuard implements CanActivate {
  constructor(
    @Inject(AUTH_PROVIDER_TOKEN) private authProvider: AuthProvider,
    private authGuardService: AuthGuardService,
    private oktaAuthGuard: OktaAuthGuard,
    private msalGuard: MsalGuard,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authProvider === 'Entra') {
      return this.msalGuard.canActivate(route, state);
    }
    return this.authProvider === 'Okta'
      ? this.oktaAuthGuard.canActivate(route, state)
      : this.authGuardService.canActivate(route, state);
  }
}
